<template>
	<section class="content">
		<div class="table-responsive">
		<table class="table table-hover w-100" ref="tablecourier">
			<thead>
				<tr>
					<th>Nama</th>
					<th>Prefix</th>
					<th>Token</th>
					<th>Username</th>
					<th>Password</th>
					<th>URL</th>
					<th>Lost&nbsp;Package</th>
					<th>Dev&nbsp;Token</th>
					<th>Dev&nbsp;User</th>
					<th>Dev&nbsp;Pass</th>
					<th>Dev&nbsp;URL</th>
					<th>Production</th>
					<th>Status</th>
					<th>Access</th>
					<th>Drop&nbsp;Off</th>
					<th>Published</th>
				</tr>
			</thead>
			<tbody @click="handleClick"></tbody>
		</table>
		</div>
		<div class="modal" tabindex="-1" role="dialog" ref="formDialog" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<form role="form" @submit="submitForm">
						<div class="modal-header">
							<h5 class="modal-title">{{ formTitle }}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<p v-if="errors.length" class="alert alert-danger alert-dismissible fade show" role="alert">
								<b>Please correct the following error(s):</b>
								<ul>
									<li v-for="error in errors" v-bind:key="error">{{ error }}</li>
								</ul>
								<button type="button" class="close" data-dismiss="alert" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							</p>
							<div class="row justify-content-sm-between">
								<div class="col-md-6 form-group">
									<label class="control-label">Nama</label>
									<input id="nama" class="form-control" v-model="form.nama" type="text" name="nama" required="required" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Prefix</label>
									<input id="prefix" class="form-control" v-model="form.prefix" type="text" name="prefix" required="required" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Username</label>
									<input id="username" class="form-control" v-model="form.username" type="text" name="username" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Token Key</label>
									<input id="token" class="form-control" v-model="form.token" type="text" name="token" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Password</label>
									<input id="password" class="form-control" v-model="form.password" type="text" name="password" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">URL</label>
									<input id="url" class="form-control" v-model="form.url" type="text" name="url" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Lost Package</label>
									<div class="input-group">
										<input id="auto_claim" class="form-control" v-model="form.auto_claim_lost_package" type="number" min="0" name="auto_claim" />
										<div class="input-group-append">
											<span class="input-group-text">Hari</span>
										</div>
									</div>
								</div>

								<div class="col-md-12">
									<hr class="mt-2" />
								</div>

								<div class="col-md-6 form-group">
									<label class="control-label">Dev Username</label>
									<input id="dev_username" class="form-control" v-model="form.dev_username" type="text" name="dev_username" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Dev Token</label>
									<input id="dev_token" class="form-control" v-model="form.dev_token" type="text" name="dev_token" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Dev Password</label>
									<input id="dev_password" class="form-control" v-model="form.dev_password" type="text" name="dev_password" />
								</div>
								<div class="col-md-6 form-group">
									<label class="control-label">Dev URL</label>
									<input id="dev_url" class="form-control" v-model="form.dev_url" type="text" name="dev_url" />
								</div>

								<div class="col col-sm-auto col-lg-6">
									<div class="icheck-material-orange w-100">
										<input type="checkbox" id="active" v-model="form.active" />
										<label for="active" class="form-check-label w-100 font-weight-bold">{{ form.active ? '' : 'Not' }} Active</label>
									</div>
								</div>
								<div class="col col-sm-auto col-lg-6">
									<div class="icheck-material-orange w-100">
										<input type="checkbox" id="production" v-model="form.production" />
										<label for="production" class="form-check-label w-100 font-weight-bold">{{ form.production ? 'Production' : 'Development' }}</label>
									</div>
								</div>
								<div class="col col-sm-auto col-lg-6">
									<div class="icheck-material-orange w-100">
										<input type="checkbox" id="auto_access" v-model="form.auto_access" />
										<label for="auto_access" class="form-check-label w-100 font-weight-bold">{{ form.auto_access ? 'Auto' : 'Manual' }}&nbsp;Access</label>
									</div>
								</div>
								<div class="col col-sm-auto col-lg-6">
									<div class="icheck-material-orange w-100">
										<input type="checkbox" id="dropoff" v-model="form.dropoff" />
										<label for="dropoff" class="form-check-label w-100 font-weight-bold">Drop&nbsp;Off</label>
									</div>
								</div>
								<div class="col col-4 col-sm-auto col-lg-6">
									<div class="icheck-material-orange w-100">
										<input type="checkbox" id="published" v-model="form.published" />
										<label for="published" class="form-check-label w-100 font-weight-bold">{{ form.published ? 'Published' : 'Limited' }}</label>
									</div>
								</div>
								<div class="col"></div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="submit" class="btn btn-primary" :disabled="loading">
								{{ method == 'POST' ? 'Simpan' : 'Update' }}
								<span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							</button>
							<button
								type="button"
								class="btn btn-secondary"
								data-dismiss="modal"
							>
								Batal
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
	<!-- /.content -->
</template>
<script>
import { createTable, authFetch } from "@/libs/hxcore";
import Swal from "sweetalert2";
import "icheck-material";
import $ from "jquery";

export default {
	name: "Data Kurir",
	data() {
		return {
			errors: [],
			method: "",
			roles: "",
			loading: false,
			formTitle: "Tambah Kurir",
			form: {
				nama: "",
				prefix: "",
				token: "",
				username: "",
				password: "",
				url: "",
				auto_claim: 0,
				dev_token: "",
				dev_username: "",
				dev_password: "",
				dev_url: "",
				active: [],
				production: [],
				auto_access: [],
				dropoff: [],
				published: [],
			},
		};
	},
	created: function () {
		this.roles = this.$route.meta.roles;
		console.log("load initial data", this.$route);
	},
	methods: {
		handleClick(e) {
			if (e.target.matches(".link-role")) {
				this.$router.push({ path: "/permit/" + e.target.dataset.id });
				return false;
			}
		},
		submitForm: function (ev) {
			this.loading = true;
			const e = this.$refs;
			var data = Object.keys(this.form)
				.map(
					(key) =>
						encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key])
				)
				.join("&");

			authFetch("/master/courier" + (this.method == 'PUT' ? '/' + this.form.id : ''), {
				method: this.method,
				body: data,
			})
				.then((res) => {
					if (res.status === 201) {
					} else if (res.status === 400) {
					}
					this.loading = false;
					return res.json();
				})
				.then((js) => {
					this.errors = [];
					if (!js.success) {
						console.log(js.details);

						for (var key in js.details) {
							if (js.details.hasOwnProperty(key)) {
								this.errors.push(js.details[key]);
							}
						}

						return;
					}
					this.table.api().ajax.reload();
					$(e.formDialog).modal("hide");
				});

			ev.preventDefault();
		},
	},
	mounted() {
		const e = this.$refs;
		var self = this;
		this.table = createTable(e.tablecourier, {
			title: "Data Kurir",
			roles: this.$route.params.roles,
			processing: true,
			scrollX: true,
			language: {
				processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
			ajax: "/master/courier",
			columns: [
				{ data: "nama" },
				{ data: "prefix" },
				{ data: "token", sortable: false },
				{ data: "username", sortable: false },
				{ data: "password", sortable: false },
				{ data: "url", sortable: false },
				{ data: "auto_claim_lost_package", sortable: false },
				{ data: "dev_token", sortable: false },
				{ data: "dev_username", sortable: false },
				{ data: "dev_password", sortable: false },
				{ data: "dev_url", sortable: false },
				{ data: "production", sortable: false },
				{ data: "active", sortable: false },
				{ data: "auto_access", sortable: false },
				{ data: "dropoff", sortable: false },
				{ data: "published", sortable: false },
			],
			filterBy: [0, 1],
			rowCallback: function (row, data) {
				$("td:eq(3)", row).html(
					'<a class="link link-role" data-id="' + data.nama + '">' + "</a>"
				);

				if (data.token) {
					$("td:eq(2)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.username) {
					$("td:eq(3)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.password) {
					$("td:eq(4)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.url) {
					$("td:eq(5)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.auto_claim_lost_package >= 1) {
					$("td:eq(6)", row).html(
						data.auto_claim_lost_package + (data.auto_claim_lost_package > 1 ? "\u0020Days" : "\u0020Day")
					);
				} else {
					$("td:eq(6)", row).html(
						'Not\u0020Active'
					);
				}

				if (data.dev_token) {
					$("td:eq(7)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.dev_username) {
					$("td:eq(8)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.dev_password) {
					$("td:eq(9)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.dev_url) {
					$("td:eq(10)", row).html(
						'<h5 class="text-center"><i class="fa fa-check"></i></h5>'
					);
				}

				if (data.production == "1")
					$("td:eq(11)", row).html(
						'<span class="badge badge-success">Production</span>'
					);
				else if (data.production == "0")
					$("td:eq(11)", row).html(
						'<span class="badge badge-warning">Development</span>'
					);

				if (data.active == "1")
					$("td:eq(12)", row).html(
						'<span class="badge badge-success">Active</span>'
					);
				else if (data.active == "0")
					$("td:eq(12)", row).html(
						'<span class="badge badge-warning">Not Active</span>'
					);

				if (data.auto_access == "1")
					$("td:eq(13)", row).html(
						'<span class="badge badge-success">Auto</span>'
					);
				else if (data.auto_access == "0")
					$("td:eq(13)", row).html(
						'<span class="badge badge-warning">Manual</span>'
					);
				
				if (data.dropoff == "1")
					$("td:eq(14)", row).html(
						'<span class="badge badge-success">Enabled</span>'
					);
				else if (data.dropoff == "0")
					$("td:eq(14)", row).html(
						'<span class="badge badge-warning">Disabled</span>'
					);
				
				if (data.published == "1")
					$("td:eq(15)", row).html(
						'<span class="badge badge-success">Published</span>'
					);
				else if (data.published == "0")
					$("td:eq(15)", row).html(
						'<span class="badge badge-warning">Limited</span>'
					);
			},
			buttonClick: (evt) => {
				if (evt.role == "create") {
					self.form = {};
					self.method = "POST";
					self.errors = [];
					self.formTitle = "Tambah Kurir";
					$(e.formDialog).modal("show");
				} else if (evt.role == "update" && evt.data) {
					self.form = evt.data;
					//jika active == 0 return false, jika active == 1 return true
					self.form.production = evt.data.production == 0 ? false : true; //operator ternary
					self.form.active = evt.data.active == 0 ? false : true; //operator ternary
					self.form.auto_access = evt.data.auto_access == 0 ? false : true; //operator ternary
					self.form.dropoff = evt.data.dropoff == 0 ? false : true; //operator ternary
					self.form.published = evt.data.published == 0 ? false : true; //operator ternary
					self.method = "PUT";
					self.errors = [];
					self.formTitle = "Edit Kurir";
					$(e.formDialog).modal("show");
				} else if (evt.role == "delete" && evt.data) {
					// self.form = evt.data;
					console.log(evt);
					Swal.fire({
						title: "Hapus data?",
						icon: "question",
						denyButtonText: '<i class="fa fa-times"></i> Hapus',
						showCancelButton: true,
						showDenyButton: true,
						showConfirmButton: false,
					}).then((result) => {
						if (result.isDenied) {
							authFetch("/master/courier/" + evt.data.id, {
								method: "DELETE",
								body: "id=" + evt.data.id,
							})
								.then((res) => {
									return res.json();
								})
								.then((js) => {
									this.table.api().ajax.reload();
								});
						}
					});
				}
			},
			initComplete: function () {
				$('.loading-overlay').removeClass('show');
			},
		});
	},
};
</script>